import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface DeviceModel {
  id: number;
  name: string;
  canSendCommands: boolean;
  compatibleWialonNames: string[];
  params: string[];
  serverAddress: string;
}

@Injectable({
  providedIn: 'root',
})
export class DeviceModelsService {
  private readonly httpClient = inject(HttpClient);
  private readonly translate = inject(TranslateService);

  list(): Observable<DeviceModel[]> {
    return this.httpClient.get<DeviceModel[]>('device_models/').pipe(
      map((devices) => {
        const notSelectedText = this.translate.instant('Not selected');
        return devices.map((device) =>
          device.id === 0 ? { ...device, name: notSelectedText } : device,
        );
      }),
    );
  }
}
